module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d2YCt"))).then(() => parcelRequire('dJXJK'));